/* global Vue */
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import vSelect from 'vue-select'
import { BootstrapVue } from 'bootstrap-vue'
import VueScrollTo from 'vue-scrollto'
import VirtualCollection from 'vue-virtual-collection'
import Vue from 'vue'
import store from './store'
import { scrollListener } from './helpers'
require('./bootstrap')

// window.Vue = require('vue')

Vue.prototype._ = _

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('v-select', vSelect)

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
// Vue.component('map', require('./components/map/Map.vue').default);

Vue.use(BootstrapVue)
Vue.use(VueScrollTo, {
  container: 'main',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.use(VirtualCollection)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

window.Bus = new Vue({})
const app = new Vue({
  el: '#app',
  store
})

scrollListener(store)
